export const getInitialReminderValues = date => ({
  type: 'REMINDER',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [
    {
      failure: [],
      success: [
        {
          type: 'Opt user in'
        },
        {
          type: 'Send Tweet',
          action: 'SEND_TWEET',
          message: '',
          isPromotedTweet: true
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Retweet of a Tweet',
          action: 'NEW_TWEET',
          RetweetUrl: ''
        }
      ],
      description: 'User opt in',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Opt user out'
        },
        {
          type: 'Send reply',
          action: 'SEND_REPLY',
          message: '',
          isPromotedTweet: true
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Match hashtag',
          value: []
        },
        {
          type: 'Match handle',
          value: []
        }
      ],
      description: 'User opt out',
      operator: 'all'
    },
    {
      failure: [],
      success: [
        {
          type: 'Trigger blast',
          message: ''
        }
      ],
      platform: 'twitter',
      triggers: [
        {
          type: 'Send at specific time',
          data: date,
          expiration: 600
        }
      ],
      description: 'Reminder Blast',
      operator: 'all',
      includeOwnersTweet: true
    }
  ],
  moderated: false,
  moderators: { handles: [] },
  automated: false,
  threshold: 20,
  enableFiltering: true,
  enableBlastFiltering: true,
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/reminder/create/container/initialValues.js